<template>
  <div :class="addClasses" >
    <span v-if="item.hasResult">{{ getTranslation('CANDIDATE_' + item.result.status) }}</span>
    <span v-else>{{ getTranslation('CANDIDATE_NOTCOME') }}</span>
  </div>
</template>

<script>
export default {
  name: "ResultStatusComponent",
  props: {
    item: {
      type: Object,
      required: true
    },
    addClasses: String
  }
}
</script>

<style scoped>

</style>
